/**
 * DevExtreme (ui/scheduler/shaders/ui.scheduler.current_time_shader.horizontal.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var Shader = require("./ui.scheduler.current_time_shader");
var HorizontalCurrentTimeShader = Shader.inherit({
    _renderShader: function() {
        var groupCount = "horizontal" === this._workspace.option("groupOrientation") ? this._workspace._getGroupCount() : 1;
        this._customizeShader(this._$shader, 0);
        if (groupCount > 1) {
            for (var i = 1; i < groupCount; i++) {
                var $shader = this._createShader();
                this._customizeShader($shader, 1);
                this._shader.push($shader)
            }
        }
    },
    _customizeShader: function($shader, groupIndex) {
        var shaderWidth = this._workspace.getIndicationWidth();
        var maxWidth = this._$container.get(0).getBoundingClientRect().width;
        if (shaderWidth > maxWidth) {
            shaderWidth = maxWidth
        }
        if (shaderWidth > 0) {
            $shader.width(shaderWidth)
        }
        $shader.css("left", this._workspace._getCellCount() * this._workspace.getCellWidth() * groupIndex)
    }
});
module.exports = HorizontalCurrentTimeShader;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/scheduler/shaders/ui.scheduler.current_time_shader.horizontal.js
// module id = 1227
// module chunks = 0